module.exports = __webpack_public_path__ + "img/Button_edit.b2c9b335.svg";